// ASP Tags
import GoogleTag from 'asp/cloud/Google';
import SphereTag from 'asp/cloud/Sphere';
import RentracksTag from 'asp/cloud/Rentracks';
import A8netTag from 'asp/cloud/A8net';
import ItmTag from 'asp/cloud/Itm';
import AdTrackTag from 'asp/cloud/AdTrack';
import MoshimoTag from 'asp/cloud/Moshimo';
import ReputyTag from 'asp/cloud/Reputy';
import FelmatTag from 'asp/cloud/Felmat';

const AspTags = () => {
  return (
    <>
      <GoogleTag />
      <RentracksTag />
      <SphereTag />
      <A8netTag />
      <ItmTag />
      <AdTrackTag />
      <MoshimoTag />
      <ReputyTag />
      <FelmatTag />
    </>
  );
};
export default AspTags;
